import React, { useEffect, useState } from 'react'
import useCustomToast from '../../../hooks/useCustomToast';
import Icons from '../../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import dayjs from 'dayjs';
import Pagination from '../../../genericComponents/oldGenericComponents/tableHelperComponents/Pagination';
import LanguageTranslator from '../../../locals/LanguageTranslator';

function AddShipmentAdvice(props) {
    const { selectedData, formData } = props;
    const [lrDetailList, setLrDetailList] = useState([]);
    const customToast = useCustomToast();
    const dispatch = useDispatch();
    const digiVendStore = useSelector(state => state.digivendStore);
    const [checkedAdvice, setCheckedAdvice] = useState([]);
    const [adviceData, setAdviceData] = useState([])
    const [adviceAllData, setAdviceAllData] = useState()

    useEffect(() => {
        let payload = {
            pageNo: 1,
            pageSize: 10,
            type: 1,
            search: "",
            status: "SHIPMENT_SHIPPED",
            isLRCreation: true,
            vendorName: selectedData?.vendorName || "",
            transporter: selectedData?.transporterName || "",
            siteDetail: selectedData?.siteDetail || "",
            sortedBy: "",
            sortedIn: "",
            filter: {},
            displayName: "VENDOR_LR_PROCESSING_ALL",
            etaDate: formData?.logisticsAndDeliveryDetails?.lrETADate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrETADate)?.format("YYYY-MM-DD") : undefined
        }
        dispatchHandler(dispatch, "getShipmentAdviceAllSsRequest", payload);

        if (props?.lrDetailList?.length) {
            let lrlist = [], lrDetailListClone = [];
            props?.lrDetailList?.map((item) => {
                return lrlist.push(item.id)
            })
            props?.lrDetailList.forEach((item) => {
                let data = {
                    id: item?.id,
                    totalRequestedQty: item.totalRequestedQty,
                    dueDays: item.dueInDays,
                    remarks: "",
                    lrBales: item.unitCount,
                    shipmentAdviceNo: item.shipmentAdviceCode,
                    shipmentAdviceDate: item.shipmentDate,
                    shipmentConfirmDate: item.shipmentConfirmDate,
                    orderNumber: item.orderNumber,
                    orderCode: item.orderCode,
                    orderDate: item.poDate,
                    validFrom: item.validFrom,
                    validTo: item.validTo,
                    siteDetail: item.siteDetails,
                    transporterId: item.transporterId,
                    transporterName: item.transporterName,
                    vendorCode: item.vendorCode,
                    vendorName: item.vendorName,
                    ownerSite: item.siteDetails,
                    saTotalAmount: item.saTotalAmount != undefined ? item.saTotalAmount : "",
                    poSelectionDate: item.poSelectionDate,
                    validFromSelectionDate: item.validFromSelectionDate,
                    validToSelectionDate: item.validToSelectionDate,
                    shipmentSelectionDate: item.shipmentSelectionDate,
                    poType: item.poType,
                    orderId: item.orderId,
                    documentNumber: item.documentNumber,
                    invoiceAmount: item.invoiceAmount,
                    basicAmount: item.basicAmount
                }
                lrDetailListClone.push(data)
            })
            setLrDetailList(lrDetailListClone);
            setCheckedAdvice(lrlist);
        }

    }, []);

    useEffect(() => {
        if (digiVendStore?.getShipmentAdviceAllSsData?.isSuccess) {
            setAdviceData(digiVendStore?.getShipmentAdviceAllSsData?.data?.resource);
            setAdviceAllData(digiVendStore?.getShipmentAdviceAllSsData?.data);
        }
    }, [digiVendStore?.getShipmentAdviceAllSsData?.isSuccess])

    const onDone = () => {
        if (lrDetailList.length != 0) {
            props.updateLrDetails(lrDetailList)
            props.closeModal()
        }
        else {
            customToast({
                title: "You have to select atleast one", status: "error",
            });
        }
    }

    const checkedShipmentFun = (id) => {
        let checkedAdviceClone = [...checkedAdvice], lrDetailListClone = [...lrDetailList];
        if (checkedAdviceClone.includes(id)) {
            lrDetailListClone.splice(lrDetailListClone.findIndex(item => item.shipmentId == id), 1);
            checkedAdviceClone.splice(checkedAdviceClone.indexOf(id), 1);
        }
        else {
            checkedAdviceClone.push(id)
            let adviceDataClone = [...adviceData]
            adviceDataClone.forEach((item) => {
                if (item.shipmentId == id) {
                    let data = {
                        id: id,
                        totalRequestedQty: item.totalRequestedQty,
                        dueDays: item.dueInDays,
                        remarks: "",
                        lrBales: item.unitCount,
                        shipmentAdviceNo: item.shipmentAdviceCode,
                        shipmentAdviceDate: item.shipmentDate,
                        shipmentConfirmDate: item.shipmentConfirmDate,
                        orderNumber: item.orderNumber,
                        orderCode: item.orderCode,
                        orderDate: item.poDate,
                        validFrom: item.validFrom,
                        validTo: item.validTo,
                        siteDetail: item.siteDetails,
                        transporterId: item.transporterId,
                        transporterName: item.transporterName,
                        vendorCode: item.vendorCode,
                        vendorName: item.vendorName,
                        ownerSite: item.siteDetails,
                        saTotalAmount: item.saTotalAmount != undefined ? item.saTotalAmount : "",
                        poSelectionDate: item.poSelectionDate,
                        validFromSelectionDate: item.validFromSelectionDate,
                        validToSelectionDate: item.validToSelectionDate,
                        shipmentSelectionDate: item.shipmentSelectionDate,
                        poType: item.poType,
                        orderId: item.orderId,
                        documentNumber: item.documentNumber,
                        invoiceAmount: item.invoiceAmount,
                        basicAmount: item.basicAmount
                    }
                    lrDetailListClone.push(data)
                }
            })
        }
        setCheckedAdvice(checkedAdviceClone);
        setLrDetailList(lrDetailListClone);
        console.log(67676767677, lrDetailListClone)
    }

    console.log(8888888, lrDetailList)

    const onRefresh = () => {
        let payload = {
            pageNo: 1,
            pageSize: 10,
            type: 1,
            search: "",
            status: "SHIPMENT_SHIPPED",
            isLRCreation: true,
            vendorName: selectedData?.vendorName || "",
            transporter: selectedData?.transporterName || "",
            siteDetail: selectedData?.siteDetail || "",
            sortedBy: "",
            sortedIn: "",
            filter: {},
            displayName: "VENDOR_LR_PROCESSING_ALL",
            etaDate: formData?.logisticsAndDeliveryDetails?.lrETADate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrETADate)?.format("YYYY-MM-DD") : undefined
        }
        dispatchHandler(dispatch, "getShipmentAdviceAllSsRequest", payload);
    }

    const getTableData = (pageNo) => {
        let payload = {
            pageNo: pageNo || 1,
            pageSize: 10,
            type: 1,
            search: "",
            status: "SHIPMENT_SHIPPED",
            isLRCreation: true,
            vendorName: selectedData?.vendorName || "",
            transporter: selectedData?.transporterName || "",
            siteDetail: selectedData?.siteDetail || "",
            sortedBy: "",
            sortedIn: "",
            filter: {},
            displayName: "VENDOR_LR_PROCESSING_ALL",
            etaDate: formData?.logisticsAndDeliveryDetails?.lrETADate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrETADate)?.format("YYYY-MM-DD") : undefined
        }
        dispatchHandler(dispatch, "getShipmentAdviceAllSsRequest", payload);
    }

    const handlePagination = (e) => {
        if (e.target.id === "first" && adviceAllData?.currPage !== 1) {
            getTableData(1);
        }
        else if (e.target.id === "prev" && adviceAllData?.currPage !== 1) {
            getTableData(adviceAllData?.currPage - 1)
        }
        else if (e.target.id === "next" && adviceAllData?.currPage !== adviceAllData?.maxPage) {
            getTableData(adviceAllData?.currPage + 1);
        }
        else if (e.target.id === "last" && adviceAllData?.currPage !== adviceAllData?.maxPage) {
            getTableData(adviceAllData?.maxPage)
        }
    }

    return (
        <div className="add-shipment-modal big-add-sku">
            <div className="bigas-top">
                <div className="bigast-left">
                    <LanguageTranslator tag='h3'>Add Shipment ASN</LanguageTranslator>
                </div>
                <div className="bigast-right">
                    <GenericCustomButton type='default' onClick={() => props.closeModal()} label="Cancel" />
                    <GenericCustomButton type="primary" onClick={() => onDone()} label="Done" />
                </div>
            </div>
            <div className="bigas-body">
                <div className="create-price-list-table act-table">
                    <div className="cplt-manage">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="fix-action-btn">
                                        <ul className="rab-refresh">
                                            <li className="rab-rinner">
                                                <span onClick={() => onRefresh()}><Icons.RefreshIcon /></span>
                                            </li>
                                        </ul>
                                    </th>
                                    <th><LanguageTranslator tag="label">ASN No.</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label">ASN Date</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label" className="min-width185 widthAuto">PO Number</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label">PO Date</LanguageTranslator> </th>
                                    <th><LanguageTranslator tag="label">Shipment Confirm Date</LanguageTranslator> </th>
                                    <th><LanguageTranslator tag="label">Ship By</LanguageTranslator> </th>
                                    <th><LanguageTranslator tag="label">Vendor Name</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label">Delivery Site</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label">Valid From</LanguageTranslator></th>
                                    <th><LanguageTranslator tag="label">Valid To</LanguageTranslator> </th>
                                    <th><LanguageTranslator tag="label">Due Days</LanguageTranslator></th>
                                    <th> <LanguageTranslator tag="label">Total Qty</LanguageTranslator></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="fix-action-btn">
                                        <ul className="table-item-list">
                                            <li className="til-inner"></li>
                                        </ul>
                                    </td>
                                    <td colSpan="50">
                                        <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>Following is the primary ASN for creating LR.</LanguageTranslator>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="fix-action-btn">
                                        <ul className="table-item-list">
                                            <li className="til-inner" style={{ cursor: "not-allowed" }}>
                                                <label className="checkBoxLabel0"><input type="checkBox" checked disabled /><span style={{ cursor: "not-allowed" }} className="checkmark1"></span> </label>
                                            </li>
                                        </ul>
                                    </td>
                                    <td><label className="whiteUnset">{selectedData?.shipmentAdviceCode}</label> </td>
                                    <td><label className="colorTableText fontBold">{selectedData?.shipmentDate}</label> </td>
                                    <td> <label className={selectedData?.poStatus == "PARTIAL" ? "colorTableText fontBold" : "colorTableText fontBold"}>{selectedData?.orderNumber}</label>{selectedData?.poStatus == "PARTIAL" ? <span className="partialTable labelEvent">{selectedData?.poStatus}</span> : null}</td>
                                    <td> <label>{selectedData?.poDate}</label></td>
                                    <td> <label>{selectedData?.shipmentConfirmDate}</label></td>
                                    <td> <label className="minWid100">{selectedData?.transporterName}</label></td>
                                    <td> <label className="whiteUnset">{selectedData?.vendorName}</label></td>
                                    <td> <label>{selectedData?.siteDetails}</label></td>
                                    <td><label >{selectedData?.validFrom}</label> </td>
                                    <td><label>{selectedData?.validTo}</label> </td>
                                    <td> <label>{selectedData?.dueInDays}</label></td>
                                    <td> <label>{selectedData?.totalRequestedQty}</label></td>
                                </tr>
                                {digiVendStore?.getShipmentAdviceAllSsData?.isLoading ?
                                    <tr>
                                        <td className="fix-action-btn">
                                            <ul className="table-item-list">
                                                <li className="til-inner"></li>
                                            </ul>
                                        </td>
                                        <td colSpan="50">
                                            {formData?.logisticsAndDeliveryDetails?.lrETADate ?
                                                <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>Fetching ASNs with <i>Vendor</i>, <i>Transporter</i>, <i>Site details</i> and <i>ETA Date</i> same as that of the primary ASN.</LanguageTranslator> :
                                                <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>Fetching ASNs with <i>Vendor</i>, <i>Transporter</i> and <i>Site details</i> same as that of the primary ASN.</LanguageTranslator>}
                                        </td>
                                    </tr> :
                                    adviceData?.length === 0 ?
                                        <tr>
                                            <td className="fix-action-btn">
                                                <ul className="table-item-list">
                                                    <li className="til-inner"></li>
                                                </ul>
                                            </td>
                                            <td colSpan="50">
                                                {formData?.logisticsAndDeliveryDetails?.lrETADate ?
                                                    <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>No ASN available with <i>Vendor</i>, <i>Transporter</i>, <i>Site details</i> and <i>ETA Date</i> same as that of the primary ASN.</LanguageTranslator> :
                                                    <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>No ASN available with <i>Vendor</i>, <i>Transporter</i> and <i>Site details</i> same as that of the primary ASN.</LanguageTranslator>}
                                            </td>
                                        </tr> :
                                        <tr>
                                            <td className="fix-action-btn">
                                                <ul className="table-item-list">
                                                    <li className="til-inner"></li>
                                                </ul>
                                            </td>
                                            <td colSpan="50">
                                                {formData?.logisticsAndDeliveryDetails?.lrETADate ?
                                                    <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>Following are the ASNs with <i>Vendor</i>, <i>Transporter</i>, <i>Site details</i> and <i>ETA Date</i> same as that of the primary ASN.</LanguageTranslator> :
                                                    <LanguageTranslator tag='label' style={{ maxWidth: "none", color: "#5f6f89", fontWeight: 600 }}>Following are the ASNs with <i>Vendor</i>, <i>Transporter</i> and <i>Site details</i> same as that of the primary ASN.</LanguageTranslator>}
                                            </td>
                                        </tr>}
                                {adviceData?.map((data, key) => (data.shipmentId == selectedData?.shipmentId ? null :
                                    <tr key={key}>
                                        <td className="fix-action-btn">
                                            <ul className="table-item-list">
                                                <li className="til-inner">
                                                    <label className="checkBoxLabel0"><input type="checkBox" checked={checkedAdvice.includes(data.shipmentId)} onChange={(e) => checkedShipmentFun(data.shipmentId)} /><span className="checkmark1"></span> </label>
                                                </li>
                                            </ul>
                                        </td>
                                        <td> <label className="whiteUnset">{data.shipmentAdviceCode}</label></td>
                                        <td><label className="colorTableText fontBold">{data.shipmentDate}</label></td>
                                        <td><label className={data.poStatus == "PARTIAL" ? "colorTableText textWarning fontBold" : "colorTableText fontBold"}>{data.orderNumber}</label>{data.poStatus == "PARTIAL" ? <span className="partialTable labelEvent">{data.poStatus}</span> : null}  </td>
                                        <td> <label>{data.poDate}</label></td>
                                        <td> <label>{data.shipmentConfirmDate}</label></td>
                                        <td> <label> {data.transporterName}</label></td>
                                        <td> <label className="whiteUnset">{data.vendorName}</label></td>
                                        <td> <label>{data.siteDetails}</label></td>
                                        <td> <label>{data.validFromDate}</label></td>
                                        <td> <label>{data.validToDate}</label></td>
                                        <td> <label> {data.dueInDays}</label></td>
                                        <td><label>{data.totalRequestedQty}</label></td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="new-gen-pagination">
                    <div className="ngp-left">
                        <div className="table-page-no">
                            <span>Page:</span><input  autoComplete="off" type="number" className="paginationBorder" max={adviceAllData?.maxPage} min="1" value={adviceAllData?.currPage} />
                            <span className="ngp-total-item">Total Items: </span> <span className="bold">{adviceAllData?.resultedDataCount}</span>
                        </div>
                    </div>
                    <div className="ngp-right">
                        <div className="nt-btn">
                            <Pagination page={handlePagination}
                                prev={adviceAllData?.currPage - 1} current={adviceAllData?.currPage} maxPage={adviceAllData?.maxPage} next={adviceAllData?.currPage + 1} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddShipmentAdvice